@if (audit) {
<div class="audit-banner" role="status">
  <span class="material-symbols-outlined">visibility</span>
  <span>Audit view of <b>{{ audit.userName }}</b> — read only{{ audit.until ? ' · ends ' + audit.until : '' }}</span>
  <button type="button" (click)="leaveAudit()">Leave</button>
</div>
}
@if (isLoading$ | async) {
<mat-progress-bar mode="indeterminate"
  style="position: fixed; top: 0; left: 0; right: 0; z-index: 9999;"></mat-progress-bar>
}
<div class="alert fade show hide" role="alert" id="alert">
  <div style="display: inline-block">
    <button (click)="onClickDecline()" class="btn decline">
      <i class="fa fa-ban" aria-hidden="true"></i>
    </button>
    <button class="btn btn-success" (click)="onClickAccept()">
      <i class="fa fa-phone" aria-hidden="true"></i>
    </button>
  </div>
</div>

<!-- Global Logout Modal -->
<div class="modal" id="logoutModal" tabindex="-1" aria-hidden="true">
  <div class="modal-backdrop"></div>
  <div class="modal-wrapper">
    <div class="modal-card">
      <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close">
        <span class="material-symbols-outlined">close</span>
      </button>

      <div class="modal-icon-wrapper">
        <div class="modal-icon">
          <span class="material-symbols-outlined">logout</span>
        </div>
      </div>

      <h2 class="modal-heading">Sign Out</h2>
      <p class="modal-text">Are you sure you want to sign out of your account?</p>

      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-danger" (click)="onClickLogout()" data-dismiss="modal">
          <span class="material-symbols-outlined">logout</span>
          Sign Out
        </button>
      </div>
    </div>
  </div>
</div>
@if(showInstallTooltip){
<div class="pwa-tooltip" [@slideIn]>
  <span>To experience full app version, install now!</span>
  <button (click)="installPWA()" class="install-btn">Install</button>
  <button class="close-btn" (click)="closeTooltip()" aria-label="Close">
    <svg style="position:absolute; top:1px; left:1px" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
      viewBox="0 0 24 24">
      <path fill="currentColor"
        d="M16.066 8.995a.75.75 0 1 0-1.06-1.061L12 10.939L8.995 7.934a.75.75 0 1 0-1.06 1.06L10.938 12l-3.005 3.005a.75.75 0 0 0 1.06 1.06L12 13.06l3.005 3.006a.75.75 0 0 0 1.06-1.06L13.062 12z" />
    </svg>
  </button>
</div>
}
<router-outlet></router-outlet>
@if (appUpdate.needsFloatingButton()) {
<app-update-button [floating]="true"></app-update-button>
}
<app-task-composer></app-task-composer>
<app-alerts></app-alerts>
<app-footer></app-footer>
<!-- <button class="btn btn-primary" (click)="onReloadDoc()">refresh</button> -->
<!-- <app-header
*ngIf="router.url !== '/upload' && router.url !== '/login'"
></app-header> -->
<!-- @if (shouldShowChat()) {
  <div class="main-chat-wrapper">
    @if (showChat) {
      <app-new-group-chat style="z-index: 1" class="d-flex flex-row-reverse align-items-end z-1">
      </app-new-group-chat>
    }
    @if (showChat) {
      <app-new-single-chat style="margin-left: 1rem; z-index: 1"></app-new-single-chat>
    }
  </div>
} -->
<!-- <app-loader *ngIf="loader.getLoading()"></app-loader> -->
<!-- <ngx-loading-bar color="#fecc28" [includeSpinner]="false" height="5px"  ></ngx-loading-bar>  -->
<!-- Global Logout Modal -->